import { Downloader, DownloadType } from '../../../common/utils/downloader/interfaces/downloader.interface';
import { DownloaderFactory } from '../../../common/utils/downloader/downloader.factory';
import { ProductCardData } from '../../product-card/product-card-display';
import { getIframeHeader, getProductListDefault } from '../template/product-list-default';
import { mapProductsToArray } from '../mapping/downloader-data-mapping';
import { html, TemplateResult } from 'lit';
import { formatDateToVerbose } from '../../../common/utils/date-utils';

export class DownloaderUtil {
  /**
   * The file name to be used for the download, excluding the file extension.
   */
  private readonly fileName: string;

  /**
   * The headers to be used in the CSV file.
   */
  private readonly csvXlsxHeaders: string[];

  /**
   * The product fields for CSV and XLSX downloads.
   */
  private readonly productFields: string[];

  /**
   * The header field for PDF download.
   */
  private readonly pdfHeader: TemplateResult;

  constructor(
    fileName: string,
    csvXlsxHeaders: string[],
    productFields: string[],
    pdfHeader: TemplateResult,
  ) {
    this.csvXlsxHeaders = csvXlsxHeaders;
    this.fileName = fileName;
    this.productFields = productFields;
    this.pdfHeader = pdfHeader;
  }

  /**
   * Download the product list in the specified format.
   *
   * @param products
   * @param downloadType
   */
  download(products: ProductCardData[], downloadType: DownloadType, displayComments?: boolean): void {
    const downloader: Downloader = DownloaderFactory.getDownloader(downloadType, this.fileName);

    switch (downloadType) {
      case DownloadType.CSV:
      case DownloadType.XLSX:
        downloader.download(this.csvXlsxHeaders, mapProductsToArray(products, this.productFields));
        break;
      case DownloadType.PDF:
        downloader.download([getIframeHeader()], [[getProductListDefault(products, this.pdfHeader, displayComments)]]);
        break;
      default:
        console.error('Invalid download type');
    }
  }
}

export function handleOptionDownload(option: DownloadType, fileName: string, pdfHeader: TemplateResult, csvXlsxHeaders: string[], productFields: string[], products: ProductCardData[], displayComments?: boolean): void {
  const downloader = new DownloaderUtil(
    fileName,
    csvXlsxHeaders ?? [],
    productFields ?? [],
    pdfHeader,
  );

  downloader.download(products, option, displayComments);
}

export const dateString: string = formatDateToVerbose(new Date());
export const productListPdfHeader = (): TemplateResult => html`<span><strong>Product List for ${document.title}</strong> - ${dateString}</span>`